import PartnerBillViewIcon from '@material-ui/icons/ViewList';

import PartnerBillViewList from './PartnerBillViewList';

export default {
  list: PartnerBillViewList,
  icon: PartnerBillViewIcon,
};
